<template>
  <g-popup title="청구서" :show="true" :instKey="instKey" :width="550">
    <section class="-wrapper-tile -box-shadow-level-4">
      <div class="-wrapper-column -width-100">
        <div class="-header -px-2">
          <span>&nbsp;</span>
          <p class="-h2">{{ $t('pages_sales_payment.bill') }}</p>
          <button class="-btn borderless- start- small- icon-only-" @click="onClickClose">
            <span class="material-icons -color-gray-1 small-">close</span>
          </button>
        </div>
        <div class="-pt-4 -px-5">
          <div class="-pb-5">
            <h2 class="-font-size-14 -font-weight-medium">{{ $t('pages_sales_payment.user_detail')}}({{ invoiceDetail.invoiceNo }})</h2>
          </div>
          <div class="-border-bottom -pb-2 -mb-3">
            <h2 class="-font-size-14 -font-weight-medium" style="line-height: 1.57;">{{$t('pages_sales_payment.sales_detail')}}</h2>
          </div>
          <div class="-wrapper-column">
            <div class="-wrapper between- v-center- -pb-1">
              <p class="--wrapper -font-size-12 -color-gray-1">{{ $t('pages_sales_payment.used_amount') }}</p>
              <p id="sales-info-popup-invoice-amount" class="-number xs- -color-gray-1 -font-family-special">￦{{ invoiceDetail.amountByKrw | comma }}</p>
            </div>
            <div class="-wrapper between- v-center- -pb-2">
              <p class="--wrapper -font-size-12 -color-gray-1">{{ $t('pages_sales_payment.used_amount_vat') }}</p>
              <p id="sales-info-popup-invoice-vat"class="-number xs- -color-gray-1 -font-family-special">￦{{ invoiceDetail.vatByKrw | comma }}</p>
            </div>
            <div class="-wrapper between- v-center-">
              <p class="--wrapper -font-size-14 -color-darkgray-1 -font-weight-bold">{{ $t('pages_sales_payment.used_amount_total') }}</p>
              <p id="sales-info-popup-invoice-total-amount" class="-number l- -font-weight-bold -font-family-special" style="line-height: 1">￦{{ Number(invoiceDetail.amountByKrw) + Number(invoiceDetail.vatByKrw) | comma}}</p>
            </div>
          </div>

          <div class="-border-bottom -mt-10 -pb-2 -mb-2">
            <h2 class="-font-size-14 -font-weight-medium">{{ $t('pages_sales_payment.used_amount_detail') }}</h2>
          </div>
          <div class="-wrapper-column -pt-1" v-for="(item, index) in invoiceDetail.productFees" :key="item.productName + index" >
            <div class="-wrapper between- v-center-">
              <p id="'sales-info-popup-invoice-category-name'+item.invoiceNo" class="--wrapper -font-size-12 -color-gray-1">[{{ item.categoryName }}] {{ item.productName }}</p>
              <p id="'sales-info-popup-invoice-category-amount'+item.invoiceNo" class="-number xs- -color-gray-1 -font-family-special">￦{{  item.amountByKrw | comma }}</p>
            </div>
          </div>
          <p class="-mt-10 -description">
            {{ $t('pages_sales_payment.thanks_1') }}
            <br/>{{ $t('pages_sales_payment.thanks_2') }}
          </p>
        </div>
        <div class="-wrapper between- -border-top -p-5 -mt-8">
          <g-button variant="borderless" size="small" @click="onDownLoad" id="sales-info-popup-download-invoice">
            <g-icon tag="span" name="get_app"  width="16px" height="16px" color="gray-1">get_app</g-icon>
            <span>{{ $t('pages_sales_payment.bill_download') }}</span>
          </g-button>
          <g-button variant="primary" class="-mr-0" @click="onClickClose" id="sales-info-popup-confirm">
            <span>{{ $t('pages_sales_payment.bill_confirm') }}</span>
          </g-button>
        </div>
      </div>
    </section>
  </g-popup>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      invoiceNumber: ""
      , totalAmount: 0
    }

  },
  props: {
    instKey: {
      type: String,
      default: null
    }
  },
  methods: {
    onClickClose() {
      this.$popupManager.close(this.instKey)
    },
    onDownLoad() {
      this.openDownLoadBill({ companyCode : this.$route.query.companyCode, invoiceNo : this.invoiceDetail.invoiceNo, empNo : this.userInfo.empNo})
    },
    ...mapActions('bills', ['openDownLoadBill'])
  },
  computed: {
    ...mapGetters('bills', ['invoices', 'invoiceDetail']),
    ...mapGetters('user', ['userInfo'])
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/bill/components/BillDetailPopup2.vue